import { ReactElement, ReactNode } from 'react';
import { styled } from 'styled-components';

const TableContainer = styled.div`
  display: grid;
  grid-template-rows: min-content min-content;
  gap: 16px;
`;

interface Props {
  header: ReactNode;
  body: ReactNode;
}

const ContentBodyLayout = ({ header, body }: Props): ReactElement => (
  <TableContainer>
    {header}
    {body}
  </TableContainer>
);

export default ContentBodyLayout;
